import cx from 'classnames';

import styles from './SectionLoader.module.scss';

export const SectionLoader: React.FC = () => {
	return (
		<div className={styles.container}>
			<div aria-live="polite" className={cx('swiper-lazy-preloader', styles.loader)} role="status" />
		</div>
	);
};
